import { NgModule } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiToggleSwitchComponent } from '@components/ui-toggle-switch/ui-toggle-switch.component';

@NgModule({
    imports: [
        ComponentSharedModule,
        MatRadioModule,
        MatSlideToggleModule,
    ],
    declarations: [
        UiToggleSwitchComponent,
    ],
    exports: [
        UiToggleSwitchComponent,
    ],
})
export class UiToggleSwitchModule { }
